export default __webpack_public_path__ + "static/media/nelson.a0974b7f.jpg";